import { cn } from '@/helpers/shadcn';
import { Loader2 } from 'lucide-react';
import { loadingSpinnerMessages } from './loadingSpinner.messages';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  isDark?: boolean;
}

export function LoadingSpinner({
  size = 'lg',
  className,
  isDark = true,
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const colorClass = isDark ? 'text-primary' : 'text-white';

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <Loader2
        className={cn('animate-spin', colorClass, sizeClasses[size])}
        aria-label={loadingSpinnerMessages.ariaLabel}
      />
    </div>
  );
}
